/**
 * Whose income counts, which varies by stage (§7.5, "whose income counts at
 * each stage").
 *
 * At entry clearance the applicant is outside the UK and their income cannot
 * be counted towards the requirement — only the sponsor's. In-country, at
 * extension and settlement, the applicant's permitted UK employment can also
 * count. Relying on income that does not count at the stage is a refusal, so
 * the engine states the position rather than silently adding it up.
 */
import type { EvaluatePredicate } from "./predicate.js";

export const whose_income_counts: EvaluatePredicate = (facts) => {
  const from = facts.finances.income_from;

  if (facts.finances.route === "savings") {
    return {
      status: "NOT_APPLICABLE",
      notes: ["Savings held by either party or jointly can be counted at any stage."],
    };
  }

  if (from === null) {
    return {
      status: "PENDING_EVIDENCE",
      notes: ["Whose income is being relied on is needed."],
    };
  }

  const applicantIncomeCounts = facts.stage !== "EC";

  if (from === "sponsor") {
    return { status: "MET", value: "sponsor", notes: ["The sponsor's income counts at every stage."] };
  }

  if (!applicantIncomeCounts) {
    return {
      status: "NOT_MET",
      value: from,
      notes: [
        "At entry clearance the applicant is outside the UK, so their income cannot be counted towards the requirement — only the sponsor's.",
      ],
    };
  }

  return {
    status: "MET",
    value: from,
    notes: [
      "In-country, the applicant's income from permitted employment can be counted alongside the sponsor's.",
    ],
  };
};
